/**
 * 읽기 화면의 YouTube 미리보기 켜기 (2026-10-14).
 *
 * AxiEditor 는 영상을 iframe 이 아니라 **썸네일 + `data-youtube-id`** 로 저장한다(광고 차단·쿠키 차단에도
 * 안 깨지게 — 에디터의 lite-youtube 방식). 편집기 밖 화면에서는 누군가 «눌렀을 때 iframe 으로
 * 바꿔 주는» 일을 해야 한다 — 에디터 번들을 읽기 화면에 싣지 않으므로 여기서 한다.
 *
 * ⚠ ID 는 11자 꼴만 쓴다(서버·프론트 sanitize 가 이미 거르지만 주소에 그대로 들어가므로 한 번 더).
 */
import { YT_ID } from './allowed-styles';

export function activateYoutubeLite(wrap: HTMLElement): boolean {
  const id = wrap.getAttribute('data-youtube-id') ?? '';
  if (!YT_ID.test(id)) return false;
  const host = wrap.getAttribute('data-yt-cookie') === 'true' ? 'www.youtube.com' : 'www.youtube-nocookie.com';
  const iframe = document.createElement('iframe');
  iframe.src = `https://${host}/embed/${id}?autoplay=1&rel=0`;
  iframe.title = 'YouTube 동영상';
  iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
  iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
  iframe.setAttribute('allowfullscreen', '');
  iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
  wrap.replaceChildren(iframe);
  wrap.style.cursor = 'default';
  return true;
}

/** 본문 상자에 한 번 걸어 둔다. 미리보기 안의 「YouTube에서 열기」 링크는 그대로 링크로 둔다. */
export function bindYoutubeLite(root: HTMLElement): () => void {
  const onClick = (e: MouseEvent) => {
    const t = e.target as Element | null;
    if (!t || t.closest('a')) return;
    const wrap = t.closest<HTMLElement>('.axe-yt-lite, .open-axe-yt-lite'); // 4.0 · 3.x 저장본
    if (!wrap || !root.contains(wrap)) return;
    if (activateYoutubeLite(wrap)) e.preventDefault();
  };
  root.addEventListener('click', onClick);
  return () => root.removeEventListener('click', onClick);
}
